import { render, staticRenderFns } from "./TextNotificationPicker.vue?vue&type=template&id=78b036bc&scoped=true&"
import script from "./TextNotificationPicker.vue?vue&type=script&lang=js&"
export * from "./TextNotificationPicker.vue?vue&type=script&lang=js&"
import style0 from "./TextNotificationPicker.vue?vue&type=style&index=0&id=78b036bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b036bc",
  null
  
)

export default component.exports